import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { ref: "rootEl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, "Loading.."))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, null, 512)
  ]))
}